<template>
  <div>
    <div class="alert alert-danger text-left" role="alert" v-if="errorMsgStatus">
      {{errorMsg}}
    </div>
    <div class="alert alert-success text-left" role="alert" v-if="successMsgStatus">
      <span>{{ successMsg }}</span>
    </div>
    <!--Page Header-->
    <div class="row no-gutters mb-3 head-container">
      <div class="col-12 col-md-6 display-1">{{ agencyData.agencyName ? agencyData.agencyName : 'Agency' }} - Edit Details</div>
      <div  v-if="!activeTab3 && !activeTab4" class="col-12 col-md-6 mt-sm-2 mt-md-0 text-sm-left text-md-right">
        <button type="button" class="btn btn-outline-secondary" id="edit-agency-cancel" tabindex="1" @click="redirectToList">Cancel</button>
        <button type="button" class="btn btn-outline-success" tabindex="1" @click="saveAgency">Save Changes</button>
      </div>
    </div>
    <!--Tabbed Content-->
    <div class="mt-2 mb-4">
      <form>
        <div>
          <b-tabs content-class="mt-3">
            <b-tab title="Agency Details" :active="activeTab1" @click="checkTabStatus(false, 'am')">
              <div class="row no-gutters">
                <!--Agency Setup: Left Column-->
                <div class="col-12 col-md-6 mb-3">
                  <div class="mr-md-4 pb-3 rounded shadow-sm">
                    <div class="col-head py-2 px-3 rounded-top text-white">Agency Setup</div>
                    <div class="float-right pr-3 mt-2 smaller-font-content"><span class="star">*</span>Required</div>
                    <div class="px-3 my-2">
                      <b-form-group id="agency_section0" label-for="agency_name">
                        <div>
                          <label>Agency Name<span class='star'>*</span></label>
                        </div>
                        <b-form-input id="agency_name" name="agency_name" :disabled="!checkPermission('CreateAgency')" v-model="agencyData.agencyName" v-validate="{ required: true, min:2 }"></b-form-input>
                        <!-- This will only be shown if the preceding input has an invalid state -->
                        <b-form-invalid-feedback :force-show="true" v-show="errors.has('agency_name')">
                          {{ errors.first('agency_name') }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                      <div class="vendor-section"><input-select :fieldData="vendorOptionsArr" /></div>
                      <!-- NO AGENCY LOGO UPLOAD
                      <div class="form-group mb-3">
                        <label for="">Upload Agency Logo</label>
                        <input type="file" class="form-control-file" id="agency-logo">
                      </div>-->
                      <b-form-group id="agency_section2" label-for="agency_SID">
                        <div>
                          <label>Agency SID<span class='star'>*</span></label>
                        </div>
                        <b-form-input id="agency_SID" name="agency_SID" :disabled="true" v-model="agencyData.sid" type="number" v-validate="{ required: true }"></b-form-input>
                        <b-form-invalid-feedback :force-show="true" v-show="errors.has('agency_SID')">
                          {{ errors.first('agency_SID') }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                      <div class="vendor-section"><input-select :fieldData="appOptionsArr" /></div>
                    </div>
                  </div>
                </div>
                <!-- agency setting section -->
                <div class="col-12 col-md-6 mb-3 order-3">
                  <div class="mr-md-4 pb-3 rounded shadow-sm">
                    <div class="col-head py-2 px-3 rounded-top text-white">Agency Settings</div>
                     <div class="px-3 my-2" v-if="preFillFlag">
                      <PreFillProduct :product='productsArr' :prefillConfig="agencyData.prefillConfig" v-if="this.productsArr.length>0" :preFillselectData="preFillselectArr"  @isHomeReplacementCheck='isHomeReplacementCheck'> </PreFillProduct>
                      </div>
                      <div class="px-3 my-2">
                        <input-number-custom :fieldData="fieldData"></input-number-custom>
                      </div>
                    </div>
                </div>
                <!--Agency Details: Right Column-->
                <div class="col-12 col-md-6 mb-3 order-2">
                  <div class="ml-md-4 pb-3 rounded shadow-sm">
                    <div class="col-head py-2 px-3 rounded-top text-white">Agency Details</div>
                    <div class="px-3 py-2">
                      <b-form-group id="agency_section3" label="Phone Number" label-for="phone_number">
                        <the-mask name="phone_number" id="phone_number" type="tel" placeholder="XXX-XXX-XXXX" v-model="masked_input_value" mask="###-###-####" v-bind:class="{'form-control': true, 'error': errors.has('phone') }">
                        </the-mask>
                        <input v-show="false" name="phone" type="text" v-validate="'digits:10'" v-model="masked_input_value">
                        <b-form-invalid-feedback :force-show="true" v-show="errors.has('phone')">
                          {{ errors.first('phone') }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                      <b-form-group id="agency_section4" label="Agency Address" label-for="agency_address">
                        <b-form-input id="agency_address" name="agency_address" v-model="agencyData.address"></b-form-input>
                      </b-form-group>
                      <b-form-group id="agency_section5" label="City" label-for="agency_city">
                        <b-form-input id="agency_city" name="agency_city" v-model="agencyData.city"></b-form-input>
                      </b-form-group>
                      <div class="col-md-12 row">
                        <b-form-group id="agency_section6" label="State" class="mb-2 float-left mr-3 col-md-2 p-0" label-for="agency_state">
                          <b-form-input id="agency_state" name="agency_state" maxlength="2" v-validate="'alpha'" class="col-md-10" v-model="agencyData.state"></b-form-input>
                          <b-form-invalid-feedback :force-show="true" v-show="errors.has('agency_state')">
                            {{ errors.first('agency_state') }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group id="agency_section7" label="Zip Code" class="mb-2 float-left mr-3" label-for="agency_zipcode">
                          <b-form-input id="agency_zipcode" name="agency_zipcode" type="text" v-validate="'digits:5|length:5'" v-model="agencyData.zipCode" maxlength="5" class="state-width"></b-form-input>
                          <b-form-invalid-feedback :force-show="true" v-show="errors.has('agency_zipcode')">
                            {{ errors.first('agency_zipcode') }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab title="Appointed Carriers" :active="activeTab2" @click="checkTabStatus(true, 'ap');">
              <template v-if="appointedCarrDataChk && currentProductAppointedCarriers !== null">
                <input-product-filter-appointed :emitToMethod="'onProductSwitch'" :tabId="'ap'" :defaultProduct="selectedProduct" :productAccessData="productAccessData" @onProductSwitch="onProductSwitch"></input-product-filter-appointed>
                <AppointedCarrier :appointedcarrierdata='currentProductAppointedCarriers'></AppointedCarrier>
              </template>
              <template v-else-if="currentProductAppointedCarriers === null">
                <div id="no-carriers-message">No Carriers Available</div>
              </template>
            </b-tab>
            <!-- <b-tab title="Carrier Logins" :active="activeTab3" @click="checkTabStatus(true, 'cl');">
              <template v-if="currentProductAppointedCarriers !== null">
                <input-product-filter-appointed :emitToMethod="'onProductSwitch'" :tabId="'cl'" :defaultProduct="selectedProduct" :productAccessData="productAccessData" @onProductSwitch="onProductSwitch"></input-product-filter-appointed>
                <CarrierLogin :appointedcarrierdata='currentProductCarrierLogin' @CredentialSubmitStatus='UpdateCredentialSubmit'></CarrierLogin>
              </template>
              <template v-else-if="currentProductAppointedCarriers === null">
                <div id="no-carriers-message">No Carriers Available</div>
              </template>
            </b-tab> -->
              <b-tab  title="Carrier Logins" :active="activeTab3" @click="checkTabStatus(true, 'cl');">
              <template v-if="currentProductAppointedCarriers !== null">
                <input-product-filter-appointed :emitToMethod="'onProductSwitch'" :tabId="'cl'" :defaultProduct="selectedProduct" :productAccessData="productOnlyAutoAccessData" @onProductSwitch="onProductSwitch"></input-product-filter-appointed>
                <CarrierCredentialUpdater :agencyID='this.$route.query.agencyID' :sId='this.agencyData.sid' @CredentialSubmitStatus='UpdateCredentialSubmit' @CredentialSubmitFailStatus='UpdateCredentialFailSubmit'></CarrierCredentialUpdater>
              </template>
              <template v-else-if="currentProductAppointedCarriers === null">
                <div id="no-carriers-message">No Carriers Available</div>
              </template>
            </b-tab>
            <b-tab title="EZLynx Templates" :active="activeTab4" @click="checkTabStatus(true, 'ec');">
              <template v-if="currentProductAppointedCarriers !== null">
                <EzlynxTemplateLogin :ezlynxcredential='ezlynxTemplateData'  @EzlynxSubmitStatusFail='UpdateEzlynxSubmitFail' @EzlynxSubmitStatus='UpdateEzlynxSubmit'></EzlynxTemplateLogin>
              </template>
              <template v-else-if="currentProductAppointedCarriers === null">
                <div id="no-carriers-message">No Carriers Available</div>
              </template>
            </b-tab>
          </b-tabs>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import fetchData from '../../../services/fetchData';
import postData from '../../../services/postData';
import AppointedCarrier from './AppointedCarrier';
import CarrierLogin from './CarrierLogin';
import CarrierCredentialUpdater from './CarrierCredentialUpdater';
import PreFillProduct from './PreFillProduct';
import common from '../../../services/common';
import InputProductFilterAppointed from '../../interactive/InputProductFilterAppointed';
import EzlynxTemplateLogin from './EzlynxTemplateLogin';
import InputNumberCustom from '../../admin/interactive/InputNumberCustom';
import InputSelect from '../../admin/interactive/InputSelect';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  data() {
    return {
      checked: false,
       preFillselectArr: [], // Must be an array reference!
       testValue: 0,
      agencyData: {},
      productsArr:[],
      form: {},
      selectedProduct: null,
      currentProductAppointedCarriers: {},
      currentProductCarrierLogin:{},
      masked_input: '',
      agencyId:'',
      errorMsgStatus: false,
      successMsgStatus: false,
      successMsg: '',
      errorMsg: '',
      appointedCarrierPageData: {},
      activeTab1: true,
      activeTab2: false,
      activeTab3: false,
      activeTab4: false,
      appointedCarrDataChk: false,
      productAccessData:[],
      productOnlyAutoAccessData:[],
      applicationOptions:[{ value: null, text: 'Select' }],
      vendorOptions:[{ value: null, text: 'Select' }],
      disableApplication: true,
      ezlynxRaterCredentialData: {},
      prefillConfigData: {},
      vendorOptionsArr: {
        field_name: 'vendor',
        field_value: '',
        rules: {
          required: true,
        },
        field_type: 'select',
        values: [],
        placeholder: 'Select One',
        label: 'Vendor',
        is_enabled: false,
      },
      appOptionsArr: {
        field_name: 'application',
        field_value: '',
        rules: {
          required: true,
        },
        field_type: 'select',
        values: [],
        placeholder: 'Select One',
        label: 'QRP Application',
        is_enabled: false,
      },
      fieldData:{
        field_id: 'carrier_timeout',
        field_name: 'carrier_timeout',
        field_label: 'Max Carrier Response Timeout (seconds)',
        field_min_value: '1',
        field_max_value: '180',
        field_required: true,
        field_model:'',
        field_class: '',
        field_maxlength: '3',
        field_subtext: 'RC1 carrier requests are cancelled when the max time limit is reached. (Default: 30 seconds)',
        field_class: 'form-control',
        field_section: 'agency_section10',
      },
      // featureFlag:false,
      preFillFlag:false,
      isHomeReplacementStatus:false,
    };
  },
  components: {
    AppointedCarrier,
    CarrierLogin,
    CarrierCredentialUpdater,
    InputProductFilterAppointed,
    EzlynxTemplateLogin,
    InputNumberCustom,
    InputSelect,
    PreFillProduct
  },
  computed: {
    checkAppCarrData() {
      if (this.appointedCarrierPageData && this.appointedCarrierPageData.length > 0) {
        return true;
      }
      return false;
    },
    masked_input_value: {
      get: function () {
        return this.masked_input;
      },
      set: function (newValue) {
        this.masked_input = newValue;
        this.agencyData.phoneNumber = this.masked_input;
      },
    },
    ezlynxTemplateData() {
      return this.ezlynxRaterCredentialData;
    }
  },
  methods: {
    isHomeReplacementCheck(status){
      this.isHomeReplacementStatus=status;
    },
    preConfigFillData(){
     let prefillObj={};
     let productsArrAPIData = Object.keys(this.productsArr);
      productsArrAPIData.forEach((obj) => {
      if(this.productsArr[obj].value==='AU')
      {
      prefillObj[this.productsArr[obj].value]= { "active": false};
      }
     else
      {
      prefillObj[this.productsArr[obj].value]= { "active": false,"replacementCost":false};
      }
      });
       return prefillObj;
      },
    preConfigPostData(selectedData){
     this.prefillConfigData= this.preConfigFillData(this.productsArr);
     let prefillAPIData = Object.keys(this.prefillConfigData);
      //reset prefillConfigData object for false
      prefillAPIData.forEach((obj) => {
       for (const [key, value] of Object.entries(this.prefillConfigData[obj])) {
           this.prefillConfigData[obj].active=false;
      }
      });
      for (let i = 0; i < selectedData[0].length; i += 1)
      {
      prefillAPIData.forEach((obj) => {
        for (const [key, value] of Object.entries(this.prefillConfigData[obj])) {
         if(selectedData[0][i]===obj)
          { 
            this.prefillConfigData[obj][key]=true;
            if(key==='replacementCost')
            {
             this.prefillConfigData[obj][key]=this.isHomeReplacementStatus;
            }
          }
      }       
      })
       } 
       return this.prefillConfigData;
      
    },    
    onProductSwitch(product) {
      this.selectedProduct = product;
      const allProductsAppointedCarriers = this.appointedCarrierPageData.ProductAppointedCarriers;
      let foundStatus = false;

      for (let i = 0; i < allProductsAppointedCarriers.length; i += 1) {
        if (allProductsAppointedCarriers[i].ProductId == this.selectedProduct) {
          foundStatus = true;
          this.currentProductAppointedCarriers = allProductsAppointedCarriers[i];
        }
      }

      if (foundStatus === false) {
        this.currentProductAppointedCarriers = null;
      }
    },
    /**
     * check tab status to show appointed carrier active in navigation
     */
    checkTabStatus(ac, tabValue) {
      /** fire google analytics event */
     // if(!this.checkPermission('CreateAgency')) {  removing role based checking for QRP admin
        if (ac) {
          if (tabValue === 'ap') {
            this.$router.push({ query: { agencyID: this.$route.query.agencyID, showTab: 'ap' }})
          }
          if (tabValue === 'cl') {
            this.$router.push({ query: { agencyID: this.$route.query.agencyID, showTab: 'cl' }})
          }
          if (tabValue === 'ec') {
            this.$router.push({ query: { agencyID: this.$route.query.agencyID, showTab: 'ec' }})
          }
        } else {
          this.$router.push({ query: { agencyID: this.$route.query.agencyID, showTab: 'am' }})
        }
      //}
      this.$store.dispatch('setAppointedCarrierStatus', ac);

      if (tabValue === 'ap') {
        this.activeTab1 = false;
        this.activeTab2 = true;
        this.activeTab3 = false;
        this.activeTab4 = false;
      } else if (tabValue === 'cl') {
      this.activeTab1 = false;
      this.activeTab2 = false;
      this.activeTab3 = true;
      this.activeTab4 = false;
      } else if (tabValue === 'ec') {
      this.activeTab1 = false;
      this.activeTab2 = false;
      this.activeTab3 = false;
      this.activeTab4 = true;
      } else {
      this.activeTab1 = true;
      this.activeTab2 = false;
      this.activeTab3 = false;
      this.activeTab4 = false;
      }

        
    },
    /**
     * Redirect to agency list page
     */
    redirectToList() {
      this.$router.push({ name: 'agencymanager' });
    },
    async saveAgency() {
      let prefillConfigVal;
      if(this.productsArr.length>0)
      //this.preConfigFillData();
      if(this.preFillselectArr.length>0)
      { // this.preConfigFillData();
       prefillConfigVal=this.preConfigPostData(this.preFillselectArr);
      }
      else
       prefillConfigVal={};
       const isValid = await this.$validator.validateAll();
      if(!isValid) {
        this.activeTab1 = true;
        return false;
      }
      const requestParams = {
        url: '/agencies/'+this.agencyData.agencyId,
        data: {
          agencyName: this.agencyData.agencyName,
          sid: parseInt(this.agencyData.sid),
          appId: this.appOptionsArr.field_value,
          phoneNumber: this.agencyData.phoneNumber,
          address: this.agencyData.address,
          city: this.agencyData.city,
          state: this.agencyData.state,
          zip: this.agencyData.zipCode,
          rateCallTimeout: parseInt(this.fieldData.field_model),
          products:this.agencyData.products,
          prefillConfig:prefillConfigVal
        },
      };
      postData.postRuleDashboard(requestParams).then((response) => {

        // this.$router.push({ path: '/admin/agencies/agencymanager', query: { msg: 'agencyEdited', carrier: this.agencyData.agencyName } });
      }).catch((error) => {
        if(error && error.response && error.response.data && error.response.data.Message) {
          this.errorMsg = error.response.data.Message;
        } else {
          this.errorMsg = 'Error in saving data';
        }
        this.errorMsgStatus = true;
        setTimeout(() => {
          this.errorMsgStatus = false;
        }, 10000);
      });

      //Appointed Carrier Posting call.
      const requestParamsAppointedCarriers = {
        url: '/agencies/'+this.agencyData.agencyId+'/appointed-carriers',
        data: this.appointedCarrierPageData,
      };
      postData.postRuleDashboard(requestParamsAppointedCarriers).then((response) => {
        this.successMsg = this.agencyData.agencyName+ ' agency updated.';
        this.successMsgStatus = true;
        setTimeout(() => {
          this.successMsgStatus = false;
        }, 10000);
      }).catch((error) => {
        if(error && error.response && error.response.data && error.response.data.Message) {
          this.errorMsg = error.response.data.Message;
        } else {
          this.errorMsg = 'Error in saving data';
        }
        this.errorMsgStatus = true;
        setTimeout(() => {
          this.errorMsgStatus = false;
        }, 10000);
      });
    },
     checkPermission(permissionName) {
      return common.checkPermission(permissionName);
    },
    UpdateCredentialSubmit(){
      this.successMsg='Success: Your updates have been saved.';
      this.successMsgStatus = true;
       setTimeout(() => {
          this.successMsgStatus = false;
        }, 10000);
    },
     UpdateCredentialFailSubmit(){
     this.errorMsg='Error: An error occurred. Your updates were not saved.';
      this.errorMsgStatus = true;
       setTimeout(() => {
          this.errorMsgStatus = false;
        }, 10000);
    },
    UpdateEzlynxSubmit() {
      this.successMsg='Success: Your updates have been saved.';
      this.successMsgStatus = true;
       setTimeout(() => {
          this.successMsgStatus = false;
        }, 10000);
    },
    UpdateEzlynxSubmitFail() {
      this.errorMsg='Error: An error occurred. Your updates were not saved.';
      this.errorMsgStatus = true;
       setTimeout(() => {
          this.errorMsgStatus = false;
        }, 10000);
    },
    /**
     *  focus shift to cancel button from last field on form
     */
    checkTabSequence(e) {
      if(e.keyCode == 9) {
        if(e.preventDefault) {
            e.preventDefault();
        }
        document.getElementById('edit-agency-cancel').focus();
        return false;
      }
    },
    preFillProduct(productarr){
      
      this.optionList=[];
      let agencyAdminFlag=false;
      let productOptionItem={};
      let label;
      if(this.checkPermission('CreateAgency'))
       agencyAdminFlag=false;
       else
       agencyAdminFlag=true;
      
      const productOptionList = productarr;
        productOptionList.forEach((val) => {
          if(val.ProductType ==='AU' || val.ProductType ==='HO' )
          {
           if(val.ProductType==='AU') 
           label='Auto'
           if(val.ProductType==='HO') 
            label='Home'
           productOptionItem = {
            text: label,
            value: val.ProductType,
            disabled:agencyAdminFlag,
          };
          this.optionList.push(productOptionItem);
         }
        })
        this.optionList.sort((current,next)=>{ return current.text.localeCompare(next.text)});
        return this.optionList; 
    },
    
  },
  created() {
    /* fetchData.getDashboard('applications').then((response) => {
      if(response.data) {
        for (let aCnt = 0; aCnt < response.data.length; aCnt += 1) {
          this.applicationOptions.push({'value': response.data[aCnt].appId, 'text': response.data[aCnt].displayName })
        }
      }
    }).catch((error) => {
      
      console.log('error', error);
    }); */
    this.productOnlyAutoAccessData.push(1);
    const tabVal = this.$route.query.showTab;
    fetchData.getDashboard(`agencies/${this.$route.query.agencyID}/details`).then((response) => {
      if(response.data) {
        if(response.data.application) {
          this.appOptionsArr.values.push({'value': response.data.application.appId, 'label': response.data.application.displayName })
        }
        if(response.data.vendor) {
          this.vendorOptionsArr.values.push({'value': response.data.vendor.vendorId, 'label': response.data.vendor.vendorName })
        }
        this.agencyData = response.data;
        this.agencyData.sid = response.data.sid.toString(); // TODO: This is a temp fix for a type warning in b-form-input. API could send this over as a String instead.
        this.masked_input = response.data.phoneNumber;
        this.agencyData.application = response.data.application.appId;
        this.agencyData.vendor = response.data.vendor.vendorId;
        this.agencyData.products= response.data.products;
        this.agencyData.prefillConfig = response.data.prefillConfig;
        this.vendorOptionsArr.field_value = this.agencyData.vendor;
        this.appOptionsArr.field_value = this.agencyData.application;
        this.fieldData.field_model = response.data.rateCallTimeout;
        this.productsArr =this.preFillProduct(response.data.products);
        // if prefil config available in response then check for replacement cost flag for HO product
        if (response.data && response.data.prefillConfig && response.data.prefillConfig.HO && response.data.prefillConfig.HO.replacementCost) {
          this.isHomeReplacementStatus = response.data.prefillConfig.HO.replacementCost;
        }
      }
    }).catch((error) => {
      console.log('error', error);
    });
    if(!this.checkPermission('CreateAgency')) {
      if (tabVal === 'ap' || tabVal === 'cl' || tabVal === ''  || tabVal === 'ec') {
        let pad = [];
        fetchData.getDashboard(`agencies/${this.$route.query.agencyID}/appointed-carriers`).then((response) => {
          this.appointedCarrierPageData = response.data;
          if (this.appointedCarrierPageData.ProductAppointedCarriers) {
            for (let aCnt = 0; aCnt < this.appointedCarrierPageData.ProductAppointedCarriers.length; aCnt += 1) {
              pad.push(this.appointedCarrierPageData.ProductAppointedCarriers[aCnt].ProductId);
            }
            this.productAccessData = pad;
             if(this.productAccessData.includes(1))
             this.selectedProduct=1;
            if(this.productAccessData.includes(1)===false)
              this.selectedProduct=18;
            if(this.productAccessData.includes(1)===false && this.productAccessData.includes(18)===false)
              this.selectedProduct=21;
            if(this.productAccessData.includes(1)===false && this.productAccessData.includes(21)===false && this.productAccessData.includes(18)===false)
              this.selectedProduct=12;
          if (this.appointedCarrierPageData.ProductAppointedCarriers[0].ProductId === this.selectedProduct) {
            this.currentProductAppointedCarriers = this.appointedCarrierPageData.ProductAppointedCarriers[0];
          }
          }
          this.appointedCarrDataChk = true;
        });
      }
    } else {
        fetchData.getDashboard(`agencies/${this.$route.query.agencyID}/appointed-carriers`).then((response) => {
          this.appointedCarrierPageData = response.data;
          if (this.appointedCarrierPageData.ProductAppointedCarriers) {
            for (let aCnt = 0; aCnt < this.appointedCarrierPageData.ProductAppointedCarriers.length; aCnt += 1) {
              this.productAccessData.push(this.appointedCarrierPageData.ProductAppointedCarriers[aCnt].ProductId);
            }
            if(this.productAccessData.includes(1))
             this.selectedProduct=1;
            if(this.productAccessData.includes(1)===false)
              this.selectedProduct=18;
            if(this.productAccessData.includes(1)===false && this.productAccessData.includes(18)===false)
              this.selectedProduct=21;
            if(this.productAccessData.includes(1)===false && this.productAccessData.includes(21)===false && this.productAccessData.includes(18)===false)
              this.selectedProduct=12;
          }
          if (this.appointedCarrierPageData.ProductAppointedCarriers[0].ProductId === this.selectedProduct) {
            this.currentProductAppointedCarriers = this.appointedCarrierPageData.ProductAppointedCarriers[0];
          }
          this.appointedCarrDataChk = true;
        });
        
    }

    //Adding fetch data logic for carrier login 
     fetchData.getDashboard(`agencies/${this.$route.query.agencyID}/rater-credentials`).then((response) => {
        this.currentProductCarrierLogin = response.data;
        this.appointedCarrDataChk = true;
      });




    if (this.$route.query.showTab === 'ap') {
      gtag('config', '<%= process.env.GAID %>', { page_path: '/dashboard/agencies/edit-agency-carriers' }); // Add page view to GA
      this.activeTab1 = false;
      this.activeTab2 = true;
      this.activeTab3 = false;
      this.activeTab4 = false;
    } else if (this.$route.query.showTab === 'cl') {
     this.activeTab1 = false;
     this.activeTab2 = false;
     this.activeTab3 = true;
     this.activeTab4 = false;
    } else if (this.$route.query.showTab === 'ec') {
     this.activeTab1 = false;
     this.activeTab2 = false;
     this.activeTab3 = false;
     this.activeTab4 = true;
    } else {
     this.activeTab1 = true;
     this.activeTab2 = false;
     this.activeTab3 = false;
     this.activeTab4 = false;
    }

  },
  mounted() {
    // if(process.env.NODE_ENV ==='local' || process.env.NODE_ENV ==='development' || process.env.NODE_ENV ==='testing'|| process.env.NODE_ENV ==='stage')
    // {
    //  this.featureFlag=true;
    // }
     if(process.env.IS_PREFILL_ENABLED)
      this.preFillFlag=true;
    
    /**
     * add event listener to last field email on form to move next tab to cancel button
     */
    const myZipInput = document.getElementById("agency_zipcode");
    if(myZipInput.addEventListener) {
      myZipInput.addEventListener('keydown',this.checkTabSequence,false);
    }
  },
  destroyed() {
    // change appointed carrier link status to false
    this.$store.dispatch('setAppointedCarrierStatus', false);
  },
};
</script>
<style scoped>
/**PAGE HEADER STYLING**/
.btn-outline-secondary {
  color: #595959;
  border-color: #595959;
}
  .btn-outline-secondary:hover {
    color: #fff;
    border-color: #595959;
    background-color: #595959;
  }

/**TAB PANE STYLING**/
.tab-content .tab-pane{
  padding: 0;
  outline: none;
}

/**COLUMN STYLING**/
.col-head {
  background-color: #00162B;
}

/**FORM STYLING**/
/**Full Width: form-groups**/
form .form-group.w-full{
  width: 100%;
}

/**Extra large devices (large desktops, 1200px and up)**/
@media (min-width: 1200px) {
  form .form-group{
    width: 50%;
  }
}

/**Large devices (desktops, 992px and up)**/
@media (max-width: 992px) {
  form .form-group{
    width: 100%;
  }
}

/**Medium devices (tablets, 768px and up)**/
@media (max-width: 768px) {
  form .form-group{
    width: 100%;
  }
}
/**Small devices (landscape phones, 576px and up)**/
@media (max-width: 576px) {
  form .form-group{
    width: 100%;
  }
}
/**FIELD LABEL STYLING**/
label {
  margin-bottom: 0.25rem;
}
/**Side-by-Side fields**/
form .form-group.float-left {
  width: auto !important;
}
#no-carriers-message {
  display: flex;
  height:300px;
  justify-content: center;
  align-items: center;
  font-size:2rem;
}
</style>
<style>
/**TAB NAV STYLING**/
.nav-tabs{
  border-bottom: 2px solid #003366;
}
  .nav-tabs .nav-link{
    color: #003366;
  }
  .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link{
    color: #FFFFFF;
    background-color: #003366;
    border-color: #003366 #003366 #003366;
  }
    .nav-tabs .nav-link:hover{
      border-color: #003366 #003366 #003366;
    }
    .nav-tabs .nav-link.active{
      background-color: #003366 !important;
      border-color: #003366 #003366 #003366 !important;
    }
    .nav-tabs .nav-link.disabled{
      color: #CCCCCC;
      border: none;
    }
.tab-content {
  border: none !important;
}
.v-select.disabled .dropdown-toggle, .v-select.disabled .dropdown-toggle input, .v-select.disabled .dropdown-toggle .selected-tag {
  border: none !important;
}
.vendor-section .v-select.disabled .dropdown-toggle{
  border: 1px solid #ccc !important;
  background-color: #ededed !important;
  color: #646464 !important; 
}
.vendor-section .v-select.disabled .dropdown-toggle .selected-tag {
  background-color: #ededed !important;
  color: #646464 !important; 
}
.vendor-section .btn-group, .vendor-section .v-select {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/agencies/EditAgency.vue?5b1fc526